export { default } from "./StatsTabButtonContainer";
